import React from "react";

import AddPhaseModal from "../../../../components/Format/Refactored/Modals/AddPhaseModal";
import PhaseSettingsModal from "../../../../components/Format/Refactored/Modals/PhaseSettingsModal";
import MatchModal from "../../../../components/Format/Refactored/Modals/MatchModal";
import MatchDeleteModal from "../../../../components/Format/Refactored/Modals/MatchDeleteModal";
import GroupModal from "../../../../components/Format/Refactored/Modals/GroupModal";
import GroupDeleteModal from "../../../../components/Format/Refactored/Modals/GroupDeleteModal";
import PhaseDeleteModal from "../../../../components/Format/Refactored/Modals/PhaseDeleteModal";
import BracketModal from "../../../../components/Format/Refactored/Modals/BracketModal";
import BracketDeleteModal from "../../../../components/Format/Refactored/Modals/BracketDeleteModal";
import BracketGroupModal from "../../../../components/Format/Refactored/Modals/BracketGroupModal";
import BracketMatchModal from "../../../../components/Format/Refactored/Modals/BracketMatchModal";
import BracketSectionModal from "../../../../components/Format/Refactored/Modals/BracketSectionModal";

import ExtraPointsModal from "./ExtraPointsModal";

const FormatModals = ({
  // Shared
  isLoading,
  selectedTournament,
  selectedCategory,
  phases,

  // Add Phase
  isAddPhaseModalOpen,
  setIsAddPhaseModalOpen,
  onTemplateSelect,
  selectedTemplate,

  // Phase Settings
  isPhaseSettingsModalOpen,
  setIsPhaseSettingsModalOpen,
  editingPhase,
  setEditingPhase,
  phaseInitialData,
  setPhaseInitialData,
  onSubmitPhase,

  // Match
  isMatchModalOpen,
  setIsMatchModalOpen,
  matchMode,
  matchFormData,
  setMatchFormData,
  selectedMatchGroup,
  setSelectedMatchGroup,
  onSubmitMatch,

  // Match Delete
  isDeleteMatchModalOpen,
  setIsDeleteMatchModalOpen,
  onConfirmDeleteMatch,

  // Group
  isGroupModalOpen,
  setIsGroupModalOpen,
  groupMode,
  groupFormData,
  setGroupFormData,
  selectedGroup,
  setSelectedGroup,
  selectedPhaseForGroup,
  onSubmitGroup,

  // Group Delete
  isDeleteGroupModalOpen,
  setIsDeleteGroupModalOpen,
  onConfirmDeleteGroup,

  // Bracket
  isBracketModalOpen,
  setIsBracketModalOpen,
  bracketMode,
  bracketFormData,
  setBracketFormData,
  selectedBracket,
  setSelectedBracket,
  selectedPhaseForBracket,
  onSubmitBracket,

  // Bracket Delete
  isDeleteBracketModalOpen,
  setIsDeleteBracketModalOpen,
  onConfirmDeleteBracket,

  // Phase Delete
  isPhaseDeleteModalOpen,
  setIsPhaseDeleteModalOpen,
  phaseToDelete,
  setPhaseToDelete,
  onConfirmDeletePhase,

  // Bracket Group
  isBracketGroupModalOpen,
  setIsBracketGroupModalOpen,
  selectedBracketForGroup,
  setSelectedBracketForGroup,
  bracketGroupFormData,
  setBracketGroupFormData,
  onSubmitBracketGroup,

  // Bracket Section
  isBracketSectionModalOpen,
  setIsBracketSectionModalOpen,
  selectedBracketForSection,
  setSelectedBracketForSection,
  sectionFormData,
  setSectionFormData,
  onSubmitSection,

  // Bracket Match
  isBracketMatchModalOpen,
  setIsBracketMatchModalOpen,
  selectedBracketForMatch,
  setSelectedBracketForMatch,
  bracketMatchFormData,
  setBracketMatchFormData,
  onSubmitBracketMatch,

  // Extra Points
  isExtraPointsModalOpen,
  setIsExtraPointsModalOpen,
  selectedGroupForExtraPoints,
  setSelectedGroupForExtraPoints,
  extraPointsFormData,
  setExtraPointsFormData,
  getTeamById,
  onUpdateExtraPoints,
}) => {
  return (
    <>
      <AddPhaseModal
        isOpen={isAddPhaseModalOpen}
        onClose={() => setIsAddPhaseModalOpen(false)}
        onConfirm={onTemplateSelect}
      />

      <PhaseSettingsModal
        key={editingPhase ? (editingPhase._id || editingPhase.id) + "-edit" : "create-" + phases.length + "-" + selectedTemplate}
        isOpen={isPhaseSettingsModalOpen}
        onClose={() => {
          setIsPhaseSettingsModalOpen(false);
          setEditingPhase(null);
          setPhaseInitialData(null);
        }}
        onSubmit={onSubmitPhase}
        isLoading={isLoading}
        phases={phases}
        selectedTournament={selectedTournament}
        mode={editingPhase ? "edit" : "create"}
        initialData={phaseInitialData}
        isFirstPhase={editingPhase
          ? phases.findIndex(p => (p._id || p.id) === (editingPhase._id || editingPhase.id)) === 0
          : phases.length === 0
        }
        templateType={editingPhase ? "manualGrid" : selectedTemplate}
      />

      <MatchModal
        isOpen={isMatchModalOpen}
        onClose={() => {
          setIsMatchModalOpen(false);
          setSelectedMatchGroup(null);
          setMatchFormData({ name: "", category: "" });
        }}
        onSubmit={onSubmitMatch}
        isLoading={isLoading}
        mode={matchMode}
        initialData={matchFormData}
        categories={selectedTournament?.categories || []}
      />

      <MatchDeleteModal
        isOpen={isDeleteMatchModalOpen}
        onClose={() => {
          setIsDeleteMatchModalOpen(false);
          setSelectedMatchGroup(null);
        }}
        onConfirm={onConfirmDeleteMatch}
        isLoading={isLoading}
        matchName={selectedMatchGroup?.name || "this match"}
      />

      <GroupModal
        isOpen={isGroupModalOpen}
        onClose={() => {
          setIsGroupModalOpen(false);
          setSelectedGroup(null);
          setGroupFormData({
            name: "",
            numGroups: 1,
            teamsPerGroup: 4,
            category: "",
            timesToFaceEachOther: 1,
          });
        }}
        onSubmit={onSubmitGroup}
        isLoading={isLoading}
        mode={groupMode}
        initialData={groupFormData}
        categories={selectedTournament?.categories || []}
        phaseId={selectedPhaseForGroup?.name || ""}
        selectedCategory={selectedCategory}
      />

      <GroupDeleteModal
        isOpen={isDeleteGroupModalOpen}
        onClose={() => {
          setIsDeleteGroupModalOpen(false);
          setSelectedGroup(null);
        }}
        onConfirm={onConfirmDeleteGroup}
        isLoading={isLoading}
        groupName={selectedGroup?.name || "this group"}
      />

      <BracketModal
        isOpen={isBracketModalOpen}
        onClose={() => {
          setIsBracketModalOpen(false);
          setSelectedBracket(null);
          setBracketFormData({ name: "", teamsCount: 2 });
        }}
        onSubmit={onSubmitBracket}
        isLoading={isLoading}
        mode={bracketMode}
        initialData={bracketFormData}
        phaseId={selectedPhaseForBracket?.name || ""}
      />

      <BracketDeleteModal
        isOpen={isDeleteBracketModalOpen}
        onClose={() => {
          setIsDeleteBracketModalOpen(false);
          setSelectedBracket(null);
        }}
        onConfirm={onConfirmDeleteBracket}
        isLoading={isLoading}
        bracketName={selectedBracket?.name || "this bracket"}
      />

      <PhaseDeleteModal
        isOpen={isPhaseDeleteModalOpen}
        onClose={() => {
          setIsPhaseDeleteModalOpen(false);
          setPhaseToDelete(null);
        }}
        onConfirm={onConfirmDeletePhase}
        isLoading={isLoading}
        phaseName={phaseToDelete?.name}
      />

      <BracketGroupModal
        isOpen={isBracketGroupModalOpen}
        onClose={() => {
          setIsBracketGroupModalOpen(false);
          setSelectedBracketForGroup(null);
          setBracketGroupFormData({ name: "", numGroups: 1, teamsPerGroup: 4 });
        }}
        onSubmit={onSubmitBracketGroup}
        isLoading={isLoading}
        bracketName={selectedBracketForGroup?.bracketName || ""}
        initialData={bracketGroupFormData}
      />

      <BracketSectionModal
        isOpen={isBracketSectionModalOpen}
        onClose={() => {
          setIsBracketSectionModalOpen(false);
          setSelectedBracketForSection(null);
          setSectionFormData({ name: "" });
        }}
        onSubmit={onSubmitSection}
        isLoading={isLoading}
        bracketName={selectedBracketForSection?.bracketName || ""}
        initialData={sectionFormData}
      />

      <BracketMatchModal
        isOpen={isBracketMatchModalOpen}
        onClose={() => {
          setIsBracketMatchModalOpen(false);
          setSelectedBracketForMatch(null);
          setBracketMatchFormData({ name: "" });
        }}
        onSubmit={onSubmitBracketMatch}
        isLoading={isLoading}
        bracketName={selectedBracketForMatch?.bracketName || ""}
        initialData={bracketMatchFormData}
      />

      <ExtraPointsModal
        isOpen={isExtraPointsModalOpen}
        group={selectedGroupForExtraPoints}
        getTeamById={getTeamById}
        formData={extraPointsFormData}
        setFormData={setExtraPointsFormData}
        onSubmit={onUpdateExtraPoints}
        onClose={() => {
          setIsExtraPointsModalOpen(false);
          setSelectedGroupForExtraPoints(null);
          setExtraPointsFormData({ teamId: null, extraPoints: 0 });
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default FormatModals;
